import service from '../index';

export const findUser = async (idUsuario, idEmpresa) => {
  const { data } = await service.post('Usuario', `find/${idUsuario}`, {
    idEmpresa,
  });
  const [usuario] = data;

  if (!usuario) {
    throw new Error('Erro ao buscar usuário');
  }

  return usuario;
};
